import type { UseQueryOptions } from '@tanstack/react-query';
import { ApiError } from '../client';

/**
 * The query defaults every feature module shares.
 *
 * Extracted from `queries/index.ts` so a per-feature module can use them
 * without importing the barrel that re-exports it, which would be a cycle.
 * `index.ts` re-exports both names, so nothing that already imported them from
 * `../api/queries` had to change.
 */

/**
 * Authentication failures must not be retried: the answer will not change, and
 * retrying turns one 401 into four before the login screen appears.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && (error.isAuthError || error.isPermissionError)) return false;
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export const defaultQueryOptions = {
  retry: shouldRetry,
  staleTime: 30_000,
  refetchOnWindowFocus: false,
} satisfies Partial<UseQueryOptions>;
